import NavHistoryTritio from "../navigators/navPreparationsTritio";

import TritioAgua from "../tritio/tritioAguas";
import TritioVapor from "../tritio/tritioVapor";
import { KeysTabsAnalysis, MapeoTab } from "@app/types/samples.types";
import NavHistoryWithMeasurements from "../navigators/navPreparationswithMeasurements";
import Fe55Form from "../Fe55";
import Ni63Form from "../Ni63";
import AlfaTotalForm from "../alfaTotal";
import Iodo131Form from "../iodo131";
import DPForm from "../DP";
import {
  setsAnalysisPhasesAlfaTotal,
  setsAnalysisPhasesBR,
  setsAnalysisPhasesBT,
  setsAnalysisPhasesDP,
  setsAnalysisPhasesFe55,
  setsAnalysisPhasesIodo131,
  setsAnalysisPhasesNi63,
  setsAnalysisPhasesSR,
  setsAnalysisPhasesTritioAgua,
  setsAnalysisPhasesTritioVapor,
  setsAnalysisPhasesBPP,
  setsAnalysisPhasesIG,
  setsAnalysisPhasesGT,
  setsAnalysisPhasesPuAmCM,
} from "@app/pages/samples/config/phases/AnalysisPhases";
import SRForm from "../SR";
import BRForm from "../BR";
import BTForm from "../BT";
import BPPForm from "../BPP";
import GTForm from "../GT";
import IGForm from "../IG";
import PuAmCMForm from "../PuAmCM";

export const mapTabsNav: Record<KeysTabsAnalysis, MapeoTab> = {
  [KeysTabsAnalysis.H3_A]: {
    tab: setsAnalysisPhasesTritioAgua,
    navigator: <NavHistoryTritio />,
    form: TritioAgua,
  },
  [KeysTabsAnalysis.H3_V]: {
    tab: setsAnalysisPhasesTritioVapor,
    navigator: <NavHistoryTritio />,
    form: TritioVapor,
  },
  [KeysTabsAnalysis.Fe55]: {
    tab: setsAnalysisPhasesFe55,
    navigator: <NavHistoryWithMeasurements />,
    form: Fe55Form,
  },
  [KeysTabsAnalysis.Ni63]: {
    tab: setsAnalysisPhasesNi63,
    navigator: <NavHistoryWithMeasurements />,
    form: Ni63Form,
  },
  [KeysTabsAnalysis.AT]: {
    tab: setsAnalysisPhasesAlfaTotal,
    navigator: <NavHistoryTritio />,
    form: AlfaTotalForm,
  },
  [KeysTabsAnalysis.I131]: {
    tab: setsAnalysisPhasesIodo131,
    navigator: <NavHistoryTritio />,
    form: Iodo131Form,
  },
  [KeysTabsAnalysis.DP]: {
    tab: setsAnalysisPhasesDP,
    navigator: <NavHistoryTritio />,
    form: DPForm,
  },
  [KeysTabsAnalysis.BR]: {
    tab: setsAnalysisPhasesBR,
    navigator: <NavHistoryWithMeasurements />,
    form: BRForm,
  },
  [KeysTabsAnalysis.BT]: {
    tab: setsAnalysisPhasesBT,
    navigator: <NavHistoryWithMeasurements />,
    form: BTForm,
  },
  [KeysTabsAnalysis.Sr89]: {
    tab: setsAnalysisPhasesSR,
    navigator: <NavHistoryWithMeasurements />,
    form: SRForm,
  },
  [KeysTabsAnalysis.Sr90]: {
    tab: setsAnalysisPhasesSR,
    navigator: <NavHistoryWithMeasurements />,
    form: SRForm,
  },
  [KeysTabsAnalysis["Sr89_90"]]: {
    tab: setsAnalysisPhasesSR,
    navigator: <NavHistoryWithMeasurements />,
    form: SRForm,
  },
  [KeysTabsAnalysis.BPP]: {
    tab: setsAnalysisPhasesBPP,
    navigator: <NavHistoryTritio />,
    form: BPPForm,
  },
  [KeysTabsAnalysis.EG_GT]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },
  [KeysTabsAnalysis.EG_IT]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },

  [KeysTabsAnalysis.Pu238]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  // Variante con capitalización de la API
  ["Pu238" as KeysTabsAnalysis]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },

  [KeysTabsAnalysis.Pu239_240]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  // Variante con capitalización de la API
  ["Pu239+240" as KeysTabsAnalysis]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },

  [KeysTabsAnalysis.AM241]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  // Variante con capitalización de la API
  ["Am241" as KeysTabsAnalysis]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  [KeysTabsAnalysis.Cm243_244]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  // Variante con capitalización de la API
  ["Cm243+244" as KeysTabsAnalysis]: {
    tab: setsAnalysisPhasesPuAmCM,
    navigator: <NavHistoryTritio />,
    form: PuAmCMForm,
  },
  [KeysTabsAnalysis.GT]: {
    tab: setsAnalysisPhasesGT,
    navigator: <NavHistoryTritio />,
    form: GTForm,
  },
  [KeysTabsAnalysis.IG]: {
    tab: setsAnalysisPhasesIG,
    navigator: <NavHistoryTritio />,
    form: IGForm,
  },
  [KeysTabsAnalysis.BTBR]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },
  [KeysTabsAnalysis.AT_E]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },
  [KeysTabsAnalysis.AT_C]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },
  [KeysTabsAnalysis.AT_PP]: {
    tab: [],
    navigator: <div>No content</div>,
    form: () => null,
  },
};
